// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconAxpl } from "../../../icons/full/build/icon-axpl.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const AxplIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconAxpl.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  AxplIcon.displayName = 'AxplIcon';
}

export default AxplIcon;